import { useState } from 'react';
import { DirectSubAccountsRequest, PaginationMetaData, SubAccount } from 'vopay';
import { useApi } from '#shared/providers/Api';

const INITIAL_PAGINATION: PaginationMetaData = {
  TotalRecords: 0,
  Limit: 0,
  Offset: 0,
};

/** One account's direct sub-accounts, listed with that account's JWT (a list row's Token) as the bearer. */
export default function useDirectSubAccounts() {
  const api = useApi();
  const [fetchingDirectSubAccounts, setFetchingDirectSubAccounts] = useState(false);
  const [directSubAccounts, setDirectSubAccounts] = useState<SubAccount[]>([]);
  const [pagination, setPagination] = useState<PaginationMetaData>(INITIAL_PAGINATION);

  async function fetchDirectSubAccounts(params: DirectSubAccountsRequest, bearer: string) {
    try {
      setFetchingDirectSubAccounts(true);
      const res = await api.fetchDirectSubAccounts(params, bearer);

      if (!res.Success) {
        throw new Error(res.ErrorMessage);
      }

      setDirectSubAccounts(res.Subaccounts);
      setPagination(res.PaginationMetaData ?? INITIAL_PAGINATION);

      return res;
    } catch (error) {
      console.error(error);
      throw error;
    } finally {
      setFetchingDirectSubAccounts(false);
    }
  }

  return { fetchingDirectSubAccounts, directSubAccounts, pagination, fetchDirectSubAccounts };
}
